import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import Input from '@vtex/styleguide/lib/Input'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import { formatPrice } from '@/checkout-instore-legacy/utils/ProductUtils'
import { handleCursorPosition } from '@/checkout-instore-legacy/utils/inputUtils'

class NumberInput extends Component {
  handleChange = (e) => {
    const { intl } = this.props
    let value = e.target.value
    value = value.replace(/\D/g, '') || 0
    value = parseInt(value, 10)
    handleCursorPosition(formatPrice(value / 100, intl), this.identification)
    this.props.onChange(value)
  }

  handleFocus = (e) => {
    e.target.select()
    if (typeof this.props.onFocus === 'function') {
      this.props.onFocus(e)
    }
  }

  render() {
    const { labelId, intl } = this.props
    const value =
      this.props.value === null || this.props.value === undefined
        ? ''
        : formatPrice(this.props.value / 100, intl)

    return (
      <Input
        id={this.props.id}
        label={
          labelId
            ? intl.formatMessage({
                id: labelId,
              })
            : undefined
        }
        className={this.props.className}
        type="tel"
        value={value}
        ref={(ref) => (this.identification = ref)}
        onChange={this.handleChange}
        onFocus={this.handleFocus}
        onBlur={this.props.onBlur}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
      />
    )
  }
}

NumberInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  labelId: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  intl: intlShape.isRequired,
}

export default injectIntl(NumberInput)
